module.exports = __webpack_public_path__ + "static/media/torso_shadow.ed6d466a.svg";